import { useState, useMemo } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { func, bool, string } from 'prop-types'

const Wrapper = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  padding: 8px;
  :hover {
    border-color: rgb(74, 102, 110);
  }
  display: inline-flex;
  ${props => props.fullWidth && 'width: 100%;'}
`

const marginRight = css`
  margin-right: 8px;
`

const paddingTop = css`
  padding-top: 6px;
  margin-right: 8px;
  text-overflow: ellipsis;
`

export const CvsFilePicker = ({
  onChange,
  fileType = null,
  buttonText = 'Upload',
  placeholder = 'Select a file',
  disabled = false,
  fullWidth = false,
}) => {
  const [uploaded, setUploaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const reader = useMemo(() => {
    const temp = new FileReader()
    temp.onload = e => {
      setLoading(false)
      onChange(e.target.result)
    }
    temp.onerror = () => {}
    return temp
  }, [onChange])

  return (
    <Wrapper fullWidth={fullWidth}>
      <div>
        <input
          disabled={disabled}
          accept={fileType}
          style={{ display: 'none' }}
          id="raised-button-file"
          type="file"
          display="none"
          onChange={e => {
            reader.readAsText(e.target.files[0])
            const asArr = e.target.value.split('\\')
            setUploaded(asArr[asArr.length - 1])
          }}
        />
        <label htmlFor="raised-button-file">
          <Button
            css={marginRight}
            disabled={disabled}
            variant="contained"
            color="primary"
            component="span"
            onClick={() => setLoading(true)}
          >
            {uploaded ? 'Replace' : buttonText}
          </Button>
        </label>
      </div>
      {!loading ? (
        <div css={paddingTop}>
          <Typography variant="body1">{uploaded || placeholder}</Typography>
        </div>
      ) : (
        <Skeleton height={30} width={200} variant="text" />
      )}
    </Wrapper>
  )
}

CvsFilePicker.propTypes = {
  onChange: func.isRequired,
  fileType: string, // Must be in the format defined here: https://www.w3schools.com/tags/att_input_accept.asp
  buttonText: string,
  disabled: bool,
  placeholder: string,
  fullWidth: bool,
}
